// 検索ボックス(トリガーボタン + <dialog class="search-sidebar-card"> + 折りたたみ .advanced-search-group)の開閉。
// 案件一覧(positions/search/_box)の inline script と同じ挙動を、data 属性で宣言的に使えるようにしたもの(#1192 人材一覧から利用)。
//
//   <button type="button" class="search-trigger-btn" data-search-dialog-trigger="user-search-dialog">…</button>
//   <dialog id="user-search-dialog" class="search-sidebar-card" data-search-dialog>
//     <div class="advanced-search-group">
//       <button type="button" class="advanced-search-toggle" aria-expanded="false">…</button>
//       <div class="advanced-search-collapse">…</div>
//     </div>
//     <button type="button" class="search-dialog-close">…</button>
//   </dialog>
//
// 1100px以上では SCSS 側で <dialog> を常時表示のパネルにしているため、トリガー/閉じるは狭い画面でだけ意味を持つ。
export function initSearchDialogs(root = document) {
  root.querySelectorAll('dialog[data-search-dialog]').forEach((dialog) => {
    if (dialog.dataset.searchDialogBound) return
    dialog.dataset.searchDialogBound = 'true'

    root.querySelectorAll(`[data-search-dialog-trigger="${dialog.id}"]`).forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (!dialog.open) dialog.showModal()
      })
    })
    dialog.querySelectorAll('.search-dialog-close').forEach((btn) => {
      btn.addEventListener('click', () => dialog.close())
    })
    // 背景クリックで閉じる
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close()
    })

    // 条件検索/詳細検索の開閉(アイコン回転 + 高さアニメーション)。
    // 開いている間は中身(第一子)を ResizeObserver で観測し、ネストした開閉やフォント読み込みで高さが変わっても追従する。
    dialog.querySelectorAll('.advanced-search-group').forEach((group) => {
      const toggle = group.querySelector(':scope > .advanced-search-toggle')
      const collapse = group.querySelector(':scope > .advanced-search-collapse')
      if (!toggle || !collapse) return

      const ro = new ResizeObserver(() => {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          collapse.style.maxHeight = `${collapse.scrollHeight}px`
        }
      })
      if (collapse.firstElementChild) ro.observe(collapse.firstElementChild)

      toggle.addEventListener('click', () => {
        const opened = toggle.getAttribute('aria-expanded') === 'true'
        toggle.setAttribute('aria-expanded', String(!opened))
        collapse.style.maxHeight = opened ? null : `${collapse.scrollHeight}px`
      })
    })
  })
}
